import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject } from 'intact-vue-next';
import { ROOT_MENU } from './menu';
import template from './title.vdt';
import { useConfigContext } from '../config';
export var MenuTitle = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MenuTitle, _Component);
  function MenuTitle() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.rootMenu = inject(ROOT_MENU);
    _this.config = useConfigContext();
    return _this;
  }
  return MenuTitle;
}(Component);
MenuTitle.template = template;